import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { ArrowRight, BadgeCheck, FileText } from 'lucide-react';
import { motion } from 'framer-motion';
import {
    FaShieldAlt,        // For Zero Depreciation Cover
    FaTools,            // For Engine Protection
    FaTruckPickup,      // For Roadside Assistance
    FaOilCan,           // For Consumables Cover
    FaUserShield,       // For Personal Accident Cover
    FaCloudSunRain,
    FaUserLock,
    FaCarCrash,
    FaCarSide,
} from "react-icons/fa";
import FAQSchema from "../../FAQSchema";
import AdBanner from "../AdPage/AdBanner";

function Icon({ id, open }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.5 8.25l-7.5 7.5-7.5-7.5"
      />
    </svg>
  );
}

const BajajTwoWheelerInsurance = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [insuranceData, setInsuranceData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const faqs = [
    {
      question: "Is insurance mandatory for Bajaj bikes?",
      answer: "Yes, at least third-party insurance is legally required in India.",
    },
    {
      question: "Which Bajaj model has the cheapest insurance?",
      answer: "CT100 and Platina typically have the lowest premiums due to lower IDV.",
    },
    {
      question: "Can I buy or renew Bajaj bike insurance online?",
      answer: "Yes, most insurers offer 100% digital purchase and renewal.",
    },
    {
      question: "Should I buy zero depreciation cover?",
      answer: "Highly recommended for Pulsar, Avenger, and Dominar owners.",
    },
    {
      question: "Does comprehensive insurance include theft coverage?",
      answer: "Yes, comprehensive plans cover theft, accidents, and natural damage.",
    },
    {
      question: "What is the penalty for not renewing my insurance on time?",
      answer: "You may lose NCB and have to go through vehicle inspection again.",
    },
    {
      question: "Can I transfer my insurance if I sell my Bajaj bike?",
      answer: "Yes, the new owner can get the policy transferred with insurer approval.",
    },
    {
      question: "Is roadside assistance useful for Bajaj cruisers like Avenger?",
      answer: "Yes, it’s very helpful during long rides or trips to remote areas.",
    },
    {
      question: "Are aftermarket modifications covered?",
      answer: "Only if declared at the time of buying or renewing your policy.",
    },
    {
      question: "Can I add coverage for pillion riders?",
      answer: "Yes, some insurers offer optional pillion accident cover.",
    },
    {
      question: "Is Dominar 400 expensive to insure?",
      answer: "Its premium is higher than commuter bikes but reasonable for the segment.",
    },
    {
      question: "Does TheFinMaster help compare plans for Bajaj bikes?",
      answer: "Yes, TheFinMaster allows you to check and compare plans across top insurers.",
    },
    {
      question: "Can I get insurance for an old Bajaj model?",
      answer: "Yes, even older Bajaj models are eligible, though options may be limited.",
    },
    {
      question: "Are electric Bajaj bikes covered too?",
      answer: "Yes, EVs like Bajaj Chetak are covered under separate EV policies.",
    },
    {
      question: "Is engine damage due to rainwater covered?",
      answer: "Only with an engine protection add-on.",
    },
    {
      question: "Do I get cashless repair options?",
      answer: "Yes, if your insurer has tie-ups with Bajaj service centers or partner garages.",
    },
    {
      question: "What happens if I miss my insurance renewal date?",
      answer: "You lose your NCB, and your bike remains uninsured during the lapse.",
    },
    {
      question: "Can I upgrade from third-party to comprehensive during renewal?",
      answer: "Yes, upgrades are allowed at renewal time.",
    },
    {
      question: "Are digital copies of insurance valid during traffic checks?",
      answer: "Yes, e-copies stored on DigiLocker or mParivahan are legally valid.",
    },
    {
      question: "How much time does claim processing take?",
      answer: "Usually 5–7 working days, depending on insurer and claim complexity.",
    },
  ];

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const cardsNew = [
    {
      title: "Zero Depreciation Cover",
      description: "Ideal for Pulsar and Dominar owners to avoid part depreciation costs.",
      icon: <FaShieldAlt className="text-4xl text-red-500 mb-4" />,
    },
    {
      title: "Engine Protection",
      description: "Useful in cities prone to waterlogging and monsoon damage.",
      icon: <FaTools className="text-4xl text-yellow-600 mb-4" />,
    },
    {
      title: "Roadside Assistance",
      description: "Helps in case of battery failure, flat tyres, or mechanical issues during trips.",
      icon: <FaTruckPickup className="text-4xl text-blue-500 mb-4" />,
    },
    {
      title: "Consumables Cover",
      description: "Covers oil, bolts, nuts, and fluids during repairs.",
      icon: <FaOilCan className="text-4xl text-green-600 mb-4" />,
    },
    {
      title: "Personal Accident Cover",
      description: "Mandatory for the owner-driver; highly recommended for regular riders.",
      icon: <FaUserShield className="text-4xl text-purple-600 mb-4" />,
    },
  ];

  const features = [
    { icon: '🛡️', text: 'Reliable & Accurate Estimates' },
    { icon: '⏱️', text: 'Takes Less Than a Minute' },
    { icon: '📉', text: 'Instantly Shows Premium Breakup' },
    { icon: '📄', text: 'No Paperwork or Documentation' },
    { icon: '📲', text: 'Easy to Use on Any Device' },
    { icon: '💰', text: 'Helps You Save on Insurance' },
  ];
const bajajinsurance = [
    {
      name: "Pulsar 125",
      path: "/bajaj-pulsar125-bike-insurance", 
      image: "/assets/bajajpulsar125.jpeg",
    },
 
     {
      name: "Platina",
      path: "/bajaj-platina-bike-insurance", 
      image: "/assets/bajajplatina.jpeg",
    },
    {
      name: "Pulsar 200",
      path: "/bajaj-pulsar200-bike-insurance", 
      image: "/assets/bajajpulsar200.jpeg",
    },
       {
      name: "Chetak",
      path: "/bajaj-chetak-bike-insurance", 
      image: "/assets/bajajchetak.jpeg",
    },
    {
      name: "PulsarN160",
      path: "/bajaj-pulsar-n160-bike-insurance", 
      image: "/assets/bajajpulsarn160.jpeg",
    },
        {
      name: "PulsarNS400",
      path: "/bajaj-pulsar-ns400-bike-insurance", 
      image: "/assets/bajajpulsarns400.jpeg",
    },
       {
      name: "Dominar400",
      path: "/bajaj-dominar-400-bike-insurance", 
      image: "/assets/bajajdominar400.jpeg",
    },
      
  ];
  return (
    <>
      <Helmet>
        <title>Bajaj Two-Wheeler Insurance in India – Compare Quotes & Buy Online</title>
        <meta
          name="description"
          content="Explore Bajaj two-wheeler insurance options in India. Compare quotes, customize coverage, and buy online to protect your Bajaj bike."
        />
        <meta
          name="keywords"
          content="bajaj two-wheeler insurance, bike insurance india, bajaj pulsar insurance, bajaj dominar insurance, bajaj platina insurance, two-wheeler insurance quotes"
        />
          <link rel="canonical" href="https://thefinmaster.com/bajaj-two-wheeler-insurance" />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:standard"
        />
        <meta name="robots" content="max-video-preview:-1" />
        {/* <link rel="canonical" href="https://thefinmaster.com/bajaj-two-wheeler-insurance" />
        <meta name="robots" content="max-snippet:-1, max-image-preview:standard, max-video-preview:-1" />
        <meta property="og:title" content="Bajaj Two-Wheeler Insurance in India" />
        <meta property="og:description" content="Compare and buy Bajaj two-wheeler insurance online with ease." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://thefinmaster.com/bajaj-two-wheeler-insurance" />
        <meta name="twitter:card" content="summary_large_image" /> */}
      </Helmet>
      <FAQSchema faqs={faqs} />
      <div className="w-full flex justify-center items-center px-4 mt-20">
        <div className="w-full max-w-5xl h-auto object-contain rounded-lg shadow-md transition duration-300 hover:scale-105">
          <AdBanner displayOrder="1" />
        </div>
      </div>
      <nav className="text-gray-500 text-sm my-4 ml-10" aria-label="Breadcrumb">
        <ol className="list-none p-0 inline-flex">
          <li className="flex items-center">
            <Link to="/" className="text-blue-600 hover:text-blue-800">Home</Link>
            <svg
              className="w-4 h-4 mx-2 text-gray-500"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z"
                clipRule="evenodd"
              />
            </svg>
          </li>
          <li className="flex items-center">
            <span className="text-gray-500">Bajaj Two-Wheeler Insurance</span>
          </li>
        </ol>
      </nav>
      <div className="w-full flex flex-col items-center">
        <div className="w-full flex justify-center">
          <div className="w-full sm:w-[95%] flex flex-col sm:flex-row justify-center items-center">
            <div className="w-full sm:w-[50%]">
              <div className="w-[90%]">
                <h1 className="text-3xl md:text-5xl font-bold mt-6 md:mt-0 md:pl-4 pl-6">
                  <span className="text-blue-600">Bajaj Two-Wheeler Insurance </span> 
                </h1>
                <p className="text-lg md:text-base lg:text-lg mt-4 pl-4">
                Bajaj is known for its powerful performance, durability, and value-for-money motorcycles. Whether you ride a commuter-friendly Platina or a high-performance Pulsar, protecting your bike starts with the right insurance plan. This guide takes you through everything you need to know about insuring a Bajaj bike, from average premiums and model insights to useful add-ons, renewal tips, and frequently asked questions.
                </p>
              </div>
            </div>
            <div className="w-full sm:w-[50%]">
              <img
                className="w-full max-w-full mt-2"
                src="../assets/bajajinsurance.jpeg"
                alt="Bajaj Two-Wheeler"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="flex justify-center items-center p-4 mt-6">
        <div className="bg-white shadow-lg rounded-2xl p-6 max-w-7xl text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
            About Bajaj in India
          </h2>
          <p className="text-gray-600 leading-relaxed">
            Bajaj has played a pivotal role in shaping India’s two-wheeler landscape. Known for its combination of performance, mileage, and design, Bajaj’s product range suits both urban and rural riders. Models like Pulsar, Platina, CT100, Avenger, and Dominar cater to different segments — from budget commuters to long-distance tourers.
          </p>
          <p className="text-gray-600 leading-relaxed mt-3">
            Bajaj bikes are widely available, easy to maintain, and built to last, making them a popular choice for daily riders across India.
          </p>
        </div>
      </div>
       <div className="p-4 sm:p-8 bg-white">
                                                                    <h2 className="text-xl sm:text-2xl font-bold mb-6 text-center">
                                                                      Choose Your Bike Brand
                                                                    </h2>
                                                                    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
                                                                      {bajajinsurance.map((calc, index) => (
                                                                        <motion.div
                                                                          key={index}
                                                                          whileHover={{ scale: 1.04 }}
                                                                          initial={{ opacity: 0, y: 20 }}
                                                                          animate={{ opacity: 1, y: 0 }}
                                                                          transition={{ duration: 0.3, delay: index * 0.05 }}
                                                                        >
                                                                          <Link
                                                                            to={calc.path}
                                                                            className="flex flex-col items-center justify-center text-center border border-gray-200 rounded-lg p-5 bg-white shadow-sm hover:shadow-md transition-all duration-300 h-full min-h-[160px]"
                                                                          >
                                                                            <img
                                                                              src={calc.image}
                                                                              alt={calc.name}
                                                                              className="w-16 h-16 object-contain mb-2"
                                                                            />
                                                                            <span className="text-md font-medium text-gray-800 break-words leading-snug">
                                                                              {calc.name}
                                                                            </span>
                                                                          </Link>
                                                                        </motion.div>
                                                                      ))}
                                                                    </div>
                                                                  </div>
      <div className="w-full flex justify-center items-center my-6 px-4">
        <div className="w-full max-w-[984px]">
          <AdBanner displayOrder="2" />
        </div>
      </div>
      <section className="relative py-20 px-4 sm:px-8 bg-gradient-to-br from-white to-gray-100 overflow-hidden">
        <div className="absolute inset-0 z-0 pointer-events-none">
          <div className="absolute top-[-10%] left-[-10%] w-96 h-96 bg-blue-400 opacity-20 blur-3xl rounded-full"></div>
          <div className="absolute bottom-[-10%] right-[-10%] w-96 h-96 bg-purple-400 opacity-20 blur-3xl rounded-full"></div>
        </div>
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
          className="relative z-10 max-w-5xl mx-auto bg-white/90 backdrop-blur-lg rounded-2xl shadow-xl p-10"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6">
            Why Bajaj Two-Wheelers Need Insurance
          </h2>
          <p className="text-gray-700 text-lg leading-relaxed mb-6">
            Every bike on the road is exposed to multiple risks, no matter how careful the rider is. An insurance policy offers financial coverage and legal protection in case of:
          </p>
          <ul className="grid gap-4 sm:grid-cols-2 md:grid-cols-3 text-gray-700 mb-6">
            <li className="flex items-start gap-3">
              <FaCarCrash className="text-xl text-red-500 mt-1" />
              <span>Accidents or collisions</span>
            </li>
            <li className="flex items-start gap-3">
              <FaUserLock className="text-xl text-yellow-500 mt-1" />
              <span>Theft or complete loss</span>
            </li>
            <li className="flex items-start gap-3">
              <FaCloudSunRain className="text-xl text-blue-500 mt-1" />
              <span>Fire, floods, or natural calamities</span>
            </li>
            <li className="flex items-start gap-3">
              <FaShieldAlt className="text-xl text-green-500 mt-1" />
              <span>Damage to others (third-party liability)</span>
            </li>
            <li className="flex items-start gap-3">
              <FaTools className="text-xl text-indigo-500 mt-1" />
              <span>Expensive part replacements</span>
            </li>
          </ul>
          <div className="bg-indigo-50 border-l-4 border-indigo-400 p-4 rounded-lg text-indigo-700">
            With Bajaj’s popularity, having a comprehensive plan ensures that repair costs are manageable and the bike stays road-ready.
          </div>
        </motion.div>
      </section>
           <section className="bg-blue-50 py-6 px-4 sm:px-6 md:px-20 lg:px-20 rounded-3xl shadow-lg max-w-6xl mx-auto mt-10">
              <div className="flex flex-col md:flex-row justify-between items-center gap-10">
                <div className="max-w-xl space-y-6 text-center md:text-left">
                  <h2 className="text-2xl sm:text-3xl font-bold text-blue-900 leading-tight">
                    Calculate Your TwoWheeler Insurance <br />
                    in <span className="text-blue-600">Seconds</span>
                  </h2>
                  <p className="text-gray-700 text-lg">
                    Use our fast and free calculator to estimate your premium — no paperwork, no waiting.
                  </p>
                  <Link
                    to="/financial-tools-calculators/bike-insurance-calculator"
                    className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 text-lg rounded-full shadow-md transition"
                  >
                    Start Calculating <ArrowRight className="w-5 h-5" />
                  </Link>
                </div>
                <div className="space-y-4 text-left">
                  {features.map((item, index) => (
                    <div key={index} className="flex items-center gap-3">
                      <span className="text-xl" role="img" aria-label={item.text}>{item.icon}</span>
                      <span className="text-gray-800 font-medium">{item.text}</span>
                    </div>
                  ))}
                </div>
              </div>
            </section>
      <div className="container mx-auto p-6 mt-6">
        <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 text-center">
          Popular Bajaj Models and Insurance Cost Estimates
        </h2>
        <p className="text-gray-600 text-sm md:text-base mt-2 text-center">
          Below are the estimated insured declared values (IDV) and starting insurance premiums for key Bajaj models:
        </p>
        <div className="max-w-7xl mx-auto px-4 py-6">
          <div className="block md:hidden">
            {[
              { model: "Bajaj Pulsar 150/NS160", category: "Sport-Commuter Bike", idv: "1 – 1.25 Lakh", premium: "₹1,200 – ₹1,700" },
              { model: "Bajaj Pulsar N250", category: "Mid-Segment Performance", idv: "1.4 – 1.6 Lakh", premium: "₹1,400 – ₹1,900" },
              { model: "Bajaj Avenger Cruise 220", category: "Cruiser Bike", idv: "1.3 – 1.5 Lakh", premium: "₹1,300 – ₹1,800" },
              { model: "Bajaj Platina 110", category: "Budget Commuter", idv: "60,000 – 80,000", premium: "₹800 – ₹1,100" },
              { model: "Bajaj CT100/CT125X", category: "Entry-Level Bike", idv: "55,000 – 75,000", premium: "₹750 – ₹1,050" },
              { model: "Bajaj Dominar 400", category: "Power Tourer", idv: "2.2 – 2.5 Lakh", premium: "₹1,900 – ₹2,500" },
            ].map((item, index) => (
              <div key={index} className="border mb-4 p-4 rounded-lg bg-white shadow-md">
                <h3 className="font-semibold text-gray-800 mb-2">{item.model}</h3>
                <div className="text-gray-600 mb-1"><strong>Category:</strong> {item.category}</div>
                <div className="text-gray-600 mb-1"><strong>Approx. IDV:</strong> {item.idv}</div>
                <div className="text-gray-600"><strong>Starting Premium:</strong> {item.premium}</div>
              </div>
            ))}
          </div>
          <div className="hidden md:block overflow-x-auto">
            <table className="min-w-full border-collapse border border-gray-300">
              <thead className="bg-gray-100 text-gray-800">
                <tr>
                  <th className="p-3 border border-gray-300 text-left">Bajaj Model</th>
                  <th className="p-3 border border-gray-300 text-left">Segment</th>
                  <th className="p-3 border border-gray-300 text-left">Approx. IDV (₹)</th>
                  <th className="p-3 border border-gray-300 text-left">Starting Premium (₹)</th>
                </tr>
              </thead>
              <tbody className="text-gray-700">
                {[
                  ["Bajaj Pulsar 150/NS160", "Sport-Commuter Bike", "1 – 1.25 Lakh", "₹1,200 – ₹1,700"],
                  ["Bajaj Pulsar N250", "Mid-Segment Performance", "1.4 – 1.6 Lakh", "₹1,400 – ₹1,900"],
                  ["Bajaj Avenger Cruise 220", "Cruiser Bike", "1.3 – 1.5 Lakh", "₹1,300 – ₹1,800"],
                  ["Bajaj Platina 110", "Budget Commuter", "60,000 – 80,000", "₹800 – ₹1,100"],
                  ["Bajaj CT100/CT125X", "Entry-Level Bike", "55,000 – 75,000", "₹750 – ₹1,050"],
                  ["Bajaj Dominar 400", "Power Tourer", "2.2 – 2.5 Lakh", "₹1,900 – ₹2,500"],
                ].map(([model, category, idv, premium], index) => (
                  <tr key={index} className="border border-gray-300">
                    <td className="p-3 border border-gray-300">{model}</td>
                    <td className="p-3 border border-gray-300">{category}</td>
                    <td className="p-3 border border-gray-300">{idv}</td>
                    <td className="p-3 border border-gray-300">{premium}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="container mx-auto p-6 mt-2">
        <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 text-center">
          Recommended Add-Ons for Bajaj Bike Insurance
        </h2>
        <p className="text-gray-600 text-sm md:text-base mt-2 text-center">
          Choose add-ons based on how and where you ride your Bajaj bike:
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-6 mt-4">
          {cardsNew.map((card, index) => (
            <div
              key={index}
              className="border rounded-lg shadow-lg p-6 flex flex-col items-center text-center"
            >
              {card.icon}
              <h3 className="text-lg font-semibold mb-2">{card.title}</h3>
              <p className="text-gray-600">{card.description}</p>
            </div>
          ))}
        </div>
      </div>
      <div className="w-full flex justify-center items-center my-6 px-4">
        <div className="w-full max-w-[984px]">
          <AdBanner displayOrder="3" />
        </div>
      </div>
      <div className="mx-auto container p-6 mt-6">
        <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 text-center">
          Top Insurers for Bajaj Two-Wheeler Insurance
        </h2>
        <p className="text-gray-600 text-sm md:text-base mt-2 text-center">
          Leading insurance providers with strong presence and cashless garage networks for Bajaj bikes:
        </p>
        <div className="mt-6 grid md:grid-cols-3 gap-6 text-left">
          <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl">⚡</span>
            <h3 className="text-lg font-semibold text-gray-800 mt-2">Bajaj Allianz</h3>
            <p className="text-gray-700 text-sm mt-1">The in-house brand, often bundled at dealerships.</p>
          </div>
          <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl">🚗</span>
            <h3 className="text-lg font-semibold text-gray-800 mt-2">HDFC ERGO</h3>
            <p className="text-gray-700 text-sm mt-1">Fast claim process, strong digital support.</p>
          </div>
          <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl">🏥</span>
            <h3 className="text-lg font-semibold text-gray-800 mt-2">ICICI Lombard</h3>
            <p className="text-gray-700 text-sm mt-1">Reliable for high-value models like Dominar.</p>
          </div>
          <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl">💰</span>
            <h3 className="text-lg font-semibold text-gray-800 mt-2">Tata AIG</h3>
            <p className="text-gray-700 text-sm mt-1">Good for long-distance riders with flexible add-on options.</p>
          </div>
          <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl">📱</span>
            <h3 className="text-lg font-semibold text-gray-800 mt-2">Digit Insurance</h3>
            <p className="text-gray-700 text-sm mt-1">Mobile-friendly and ideal for city commuters.</p>
          </div>
        </div>
      </div>
      <div className="w-full px-2 py-6 bg-gradient-to-br from-sky-50 via-white to-sky-100 dark:from-gray-900 dark:to-gray-800">
        <div className="max-w-6xl mx-auto grid gap-10">
          <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-sky-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
            <div className="flex items-center gap-3 mb-2">
              <FileText className="w-8 h-8 text-sky-600" />
              <span className="text-2xl md:text-3xl font-bold text-gray-800 dark:text-white">
                Tips to Lower Bajaj Insurance Premium
              </span>
            </div>
            <h3 className="text-xl md:text-xl font-bold text-gray-800 dark:text-white mb-6">
              Here’s how you can keep your premium low without compromising coverage:
            </h3>
            <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
              <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                <span>Maintain No Claim Bonus (NCB) by avoiding small claims.</span>
              </div>
              <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                <span>Choose higher deductibles if you ride in safer areas.</span>
              </div>
              <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                <span>Install anti-theft devices to qualify for discounts.</span>
              </div>
              <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                <span>Avoid unnecessary add-ons based on your riding style.</span>
              </div>
              <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                <span>Compare policies online before renewal or purchase.</span>
              </div>
            </div>
          </div>
          <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-emerald-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
            <div className="flex items-center gap-3 mb-6">
              <BadgeCheck className="w-8 h-8 text-emerald-600" />
              <span className="text-2xl md:text-3xl font-bold text-gray-800 dark:text-white">
                Documents Required for Bajaj Bike Insurance
              </span>
            </div>
            <h3 className="text-xl md:text-xl font-bold text-gray-800 dark:text-white mb-6">
              Have these ready when buying or renewing your insurance:
            </h3>
            <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
              <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                <span>Registration Certificate (RC) of your Bajaj two-wheeler</span>
              </div>
              <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                <span>Previous insurance copy (if available)</span>
              </div>
              <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                <span>Pollution Under Control (PUC) certificate</span>
              </div>
              <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                <span>KYC documents (ID and address proof)</span>
              </div>
              <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl sm:col-span-2">
                <span>Recent passport-size photo (if asked)</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="max-w-4xl mx-auto py-6 px-2">
        <h2 className="text-2xl md:text-3xl font-semibold text-center mb-8">
          Bajaj Two-Wheeler Insurance FAQs
        </h2>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border rounded-lg overflow-hidden shadow-md"
            >
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
                aria-expanded={activeIndex === index}
                aria-controls={`faq-answer-${index}`}
              >
                {faq.question}
                <Icon id={index} open={activeIndex} />
              </button>
              {activeIndex === index && (
                <div id={`faq-answer-${index}`} className="p-4 bg-gray-100">
                  <p className="text-gray-700">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
      <section className="relative py-20 px-4 sm:px-8 bg-gradient-to-br from-white to-gray-100 overflow-hidden">
        <div className="absolute inset-0 pointer-events-none z-0">
          <div className="absolute top-[-20%] left-[-10%] w-96 h-96 bg-indigo-300 opacity-30 blur-3xl rounded-full"></div>
          <div className="absolute bottom-[-10%] right-[-10%] w-96 h-96 bg-purple-300 opacity-30 blur-3xl rounded-full"></div>
        </div>
        <motion.div
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
          className="relative z-10 max-w-4xl mx-auto bg-white/90 backdrop-blur-sm border border-gray-200 shadow-xl rounded-2xl p-10"
        >
          <div className="flex flex-col md:flex-row items-start md:items-center gap-6">
            <div className="text-indigo-600 text-5xl">
              <FaCarSide />
            </div>
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
                Conclusion
              </h2>
              <p className="text-gray-700 text-lg leading-relaxed mb-4">
                Bajaj bikes are dependable, economical, and built for Indian conditions. Whether you’re cruising on an Avenger, commuting daily on a Platina, or hitting top speeds on a Pulsar, the right insurance coverage ensures financial protection and peace of mind.
              </p>
              <p className="text-gray-700 text-lg leading-relaxed">
                TheFinMaster simplifies the insurance journey by helping you compare multiple insurers, pick the best policy for your Bajaj model, and manage claims with ease.
              </p>
            </div>
          </div>
        </motion.div>
      </section>
    </>
  );
};

export default BajajTwoWheelerInsurance;